import { render } from "./OrderMenuSelectOption.vue?vue&type=template&id=d1d4d274&scoped=true"
import script from "./OrderMenuSelectOption.vue?vue&type=script&lang=js"
export * from "./OrderMenuSelectOption.vue?vue&type=script&lang=js"

import "@/assets/css/style.css?vue&type=style&index=0&id=d1d4d274&scoped=true&lang=css&external"
import "./OrderMenuSelectOption.vue?vue&type=style&index=1&id=d1d4d274&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d1d4d274"]])

export default __exports__